module.exports = __webpack_public_path__ + "img/poswap.36cce305.png";